import 'view/css/worker.css';

import moment from 'moment';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faPlus } from '@fortawesome/free-solid-svg-icons';

import sha256 from 'crypto-js/sha256';
import API from 'service/api';
import Util from 'service/util';

import React from 'react';
import BasePageView from 'view/BasePageView';
import PopMessage from 'component/pop-msg/PopMessage';
import Protected from 'component/Protected';
import StaffRow from 'component/StaffRow';
import StaffModal from 'component/StaffModal';

export const TYPE = Object.freeze({
  OFFICE: 'o',
  WORKER: 'w',
  LHS: 'l'
});

class StaffView extends BasePageView
{
  constructor(props)
  {
    super(props);
    this.state = {
      staff: [],
      filter_type: TYPE.WORKER,
      filter_name: '',
      filter_loc: '',
      filter_existing: true,
      filter_active: null,
      modal: null,
      exporting: false,
    };

    this.showAddModal  = this.showAddModal.bind(this);
    this.showEditModal = this.showEditModal.bind(this);
    this.submitModal   = this.submitModal.bind(this);
    this.closeModal    = this.closeModal.bind(this);
  }

  componentDidMount()
  {
    API.getStaffList().then(staff => {
      staff?.forEach(s => {
        s.employ_dtm = s.employ_dtm ? new Date(s.employ_dtm) : null;
        s.resign_dtm = s.resign_dtm ? new Date(s.resign_dtm) : null;
      });
      this.setInitiated({staff});
    });
  }

  exportXls()
  {
    this.setState({exporting: true});
    API.exportStaffList().then(resp => {
      const ix_date = moment().format('YYYYMMDD');
      Util.download(resp, `僱員資料_${ix_date}.xlsx`);
      this.setState({exporting: false});
    });
  }

  submitModal(e, password)
  {
    e.preventDefault();
    e.stopPropagation();

    let mode = this.state.modal.mode;
    let ms   = {...this.state.modal.staff};

    ms.hkid       = ms.hkid ? ms.hkid : null;
    ms.supervisor = ms.supervisor ? ms.supervisor : null;
    ms.contacts   = ms.contacts.filter(c => c.c_num);
    ms.password   = password ? sha256(password).toString() : null;

    let query = mode === 'add'
      ? API.addStaff(ms)
      : API.editStaff(ms);

    query.then(resp => {
      if (resp.success)
      {
        let rtStf = resp.msg;
        rtStf.locations = ms.locations;
        if ('add' === mode) {
          let staff = this.state.staff; //list
          staff.push(rtStf);
          this.setState({modal: null, password: '', staff});
        } else {
          Object.assign(this.state.modal.origin, rtStf);
          this.setState({modal: null, password: ''});
        }
        PopMessage.show('已成功建立使用者', '成功', 'success');
      } else {
        PopMessage.show(resp.msg, '操作失敗', 'danger');
        let modal = {...this.state.modal};
        modal.error = resp.msg;
        this.setState({modal});
      }
    });

    return false;
  }

  showAddModal()
  {
    let staff = {
      active: true,
      contacts: [{c_type:10, c_sal:'', c_name:'', c_num:''}],
      username:'',
      password:'',
      display_name: '',
      locations: [],
      bonus_A: 0, bonus_B: 0, bonus_C: 0,
      bonus_extra: 0, allowance: 0,
      hkid: null,
      supervisor: null,
      employ_dtm: Util.getToday(),
      resign_dtm: null,
      role: 'WORKER'
    };
    this.setState({password:'', modal:{mode:'add',staff}});
  }
  showEditModal(origin)
  {
    let staff = {...origin};
    staff.contacts = JSON.parse(JSON.stringify(origin.contacts));
    this.setState({modal:{mode:'edit', staff, origin}});
  }
  closeModal()
  {
    if ('edit'===this.state.modal.mode)
      Object.assign(this.state.modal.staff, this.state.modal.origin);
    this.state.modal.staff.contacts = this.state.modal.staff.contacts.filter(c => c.c_num);
    this.setState({modal:null, password: ''});
  }

  isNoData() { return this.state.staff.success === false; }
  title = () => <>
    <span className="main-title">基本資料</span> - <span className="sub-title">僱員</span>
  </>

  filter()
  {
    let _items = this.state.staff;

    switch (this.state.filter_active)
    {
      case 'active':   _items = _items.filter(x =>  x.active); break;
      case 'inactive': _items = _items.filter(x => !x.active); break;
    }
    if (this.state.filter_existing) { _items = _items.filter(x => !x.resign_dtm); }

    switch (this.state.filter_type)
    {
      case TYPE.OFFICE: _items = _items.filter(s => s.role !== 'WORKER'); break;
      case TYPE.WORKER: _items = _items.filter(s => s.role === 'WORKER'); break;
      case TYPE.LHS:    _items = _items.filter(s => s.work_type === 'A'); break;
    }

    if (this.state.filter_name)
    {
      _items = _items.filter(s => {
        return s.display_name.toUpperCase().indexOf(this.state.filter_name) > -1;
      });
    }

    if (this.state.filter_loc)
    {
      _items = _items.filter(s => {
        if (s.locations) for (let i = 0; i < s.locations.length; i++) {
          let loc = `${s.locations[i].srv_dis}${s.locations[i].srv_loc}`.toUpperCase();
          if (loc.startsWith(this.state.filter_loc)) return true;
        }
        return false;
      });
    }

    return _items;
  }

  _render()
  {
    const FT = this.state.filter_type;

    // filter
    let _items = this.filter();

    // render
    return (
      <>
        <div className="search-bar box">
          <h4 className="box-head">
            <span>搜尋</span>
            <div className="button-group">
              <Protected allow={['ADMIN']}>
                <button className="btn small green" type="button"
                        onClick={ this.showAddModal }>
                  <FontAwesomeIcon icon={faPlus} />
                </button>
              </Protected>
            </div>
          </h4>
          <div className="box-body">
            <div className="action-panel">
              <div>
                <label className="search-field">
                  <span>類別</span>
                  <select id="s-type" value={ this.state.filter_type }
                          onChange={ e => this.setState({ filter_type: e.target.value }) }>
                    <option value={TYPE.OFFICE}>辦公室</option>
                    <option value={TYPE.WORKER}>工人</option>
                    <option value={TYPE.LHS}>優悠家居</option>
                  </select>
                </label>
                <label className="search-field">
                  <span>姓名</span>
                  <input id="f-name" value={ this.state.filter_name }
                        onChange={ e => this.setState({filter_name: e.target.value.toUpperCase()}) }/>
                </label>
                <label className="search-field">
                  <span>服務屋苑</span>
                  <input id="f-location" value={ this.state.filter_loc }
                        onChange={ e => this.setState({filter_loc: e.target.value.toUpperCase()}) }/>
                </label>
                <label className="search-field">
                  <span>在職職員</span>
                  <div>
                    <input id="f-existing" type="checkbox" checked={this.state.filter_existing}
                          onChange={e=>this.setState({filter_existing: e.target.checked})} />
                  </div>
                </label>
                <label className="search-field">
                  <span>狀態</span>
                  <select id="f-active" value={this.state.filter_active}
                          onChange={e=>this.setState({filter_active: e.target.value})}>
                    <option value="">全部</option>
                    <option value="active">有效</option>
                    <option value="inactive">無效</option>
                  </select>
                </label>
              </div>
              <div>
                <Protected allow={['ADMIN','OPERATOR','VIEWER_SU']}>
                  <button className="btn dark-green btn-export" disabled={this.state.exporting}
                    onClick={e=>this.exportXls()}>
                    <FontAwesomeIcon icon={faFileExcel} />
                    <span> 匯出</span>
                  </button>
                </Protected>
              </div>
            </div>
          </div>
        </div>
        <div className="workers">
          <table className="data-table full-width">
            <colgroup>
              <col width="20px"  id="col-staff-sel"/>
              <col width="20px"  id="col-staff-active"/>
              <col width="60px"  id="col-staff-code"/>
              <col width="120px" id="col-staff-login"/>
              <col width="120px" id="col-staff-name"/>
              { TYPE.OFFICE==FT
                ?<>
                  <Protected allow={['ADMIN']}>
                    <col width="70px" id="col-staff-hkid"/>
                  </Protected>
                  <col width="50px"  id="col-staff-rank"/>
                  <col width="120px" id="col-staff-title"/>
                  <col width="120px" id="col-staff-supervisor"/>
                  <Protected allow={['ADMIN']}>
                  <col width="80px"  id="col-staff-salary"/>
                  <col width="60px"  id="col-staff-al"/>
                  </Protected>
                </>
                :<>
                  <col width="120px" id="col-staff-supervisor"/>
                  <col width="auto"  id="col-staff-responsible-area" />
                </>
              }
              <col width="120px" id="col-staff-employ-date"/>
              <col width="120px" id="col-staff-resign-date"/>
              <col width="280px" id="col-staff-contact"/>
              <col width="100px" id="col-staff-mod-by"/>
              <col width="36px"  id="col-staff-btn-grp"/>
            </colgroup>
            <thead>
              <tr>
                <th className="col-staff-sel"></th>
                <th className="col-staff-active"></th>
                <th className="col-staff-code">編號</th>
                <th className="col-staff-login">登入名稱</th>
                <th className="col-staff-name">顯示名稱</th>
                { TYPE.OFFICE==FT
                  ?<>
                    <Protected allow={['ADMIN']}>
                      <th className="col-staff-hkid">身份證</th>
                    </Protected>
                    <th className="col-staff-rank">職級</th>
                    <th className="col-staff-title">職稱</th>
                    <th className="col-staff-supervisor">主管</th>
                    <Protected allow={['ADMIN']}>
                    <th className="col-staff-salary">月薪</th>
                    <th className="col-staff-al">年假</th>
                    </Protected>
                  </>
                  :<>
                    <th className="col-staff-supervisor">主管</th>
                    <th className="col-staff-responsible-area">負責區域</th>
                  </>
                }
                <th className="col-staff-employ-date">入職日期</th>
                <th className="col-staff-resign-date">離職日期</th>
                <th className="col-staff-contact">聯絡</th>
                <th className="col-staff-mod-by">修訂人</th>
                <th className="col-staff-btn-grp"></th>
              </tr>
            </thead>
            <tbody>
              { _items.map(s => <StaffRow key={s.id} staff={s}
                  filter={this.state.filter_type}
                  showEditModal={this.showEditModal} /> )}
            </tbody>
          </table>
        </div>
        {
          !this.state.modal?'':
          <StaffModal context={this.state.modal}
                      submitModal={this.submitModal}
                      closeModal={this.closeModal}
                      employees={this.state.staff.filter(s=>s.is_manager)}
                      />
        }
      </>
    );
  }

}

export default StaffView;